const SUPABASE_URL = 'https://xhzwvfniejgdvcpobdxm.supabase.co'
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhoend2Zm5pZWpnZHZjcG9iZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5MTcxMTksImV4cCI6MjA4OTQ5MzExOX0.G2D-hdPv_ulmiEPS2AXZ2vGaykgvAmgTqU1eyKvLtcw'
const AI_CHAT_URL = `${SUPABASE_URL}/functions/v1/ai-chat`

export const triggerChat = async function triggerChat (query) {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  const thread = [...(root.chatMessages || []), { role: 'user', content: query }]
  root.update({ chatMessages: thread, chatTyping: true })

  try {
    const res = await fetch(AI_CHAT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_KEY}`
      },
      body: JSON.stringify({
        action: 'message',
        messages: thread.filter(m => m.role && m.content)
      })
    })
    const data = await res.json()

    root.update({
      chatMessages: [...thread, {
        role: 'assistant',
        content: data.reply || 'No response received.',
        recommended: data.results || []
      }],
      chatTyping: false
    })

    const threadEl = this.lookup ? this.lookup('ThreadBody') : null
    if (threadEl && threadEl.node) {
      setTimeout(() => { threadEl.node.scrollTop = threadEl.node.scrollHeight }, 100)
    }
  } catch (err) {
    root.update({
      chatMessages: [...thread, { role: 'assistant', content: 'Error: ' + err.message }],
      chatTyping: false
    })
  }
}

export const formatChatHtml = function formatChatHtml (text) {
  if (!text) return ''
  let t = text
  t = t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  t = t.replace(/\*([^*]+)\*/g, '<em>$1</em>')
  t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" style="color:#c6ac8f;text-decoration:underline">$1</a>')
  t = t.replace(/\n/g, '<br>')
  return t
}

export const parseChatLinks = function parseChatLinks (text) {
  const links = []
  const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g
  let m
  while ((m = regex.exec(text)) !== null) {
    links.push({ label: m[1], url: m[2] })
  }
  return links
}
